// Role differences between the CWW clerk ("adminclerk"), CWW ministerial
// head ("adminsuperint") and DCF ("dcf") application pages.
// Flow: CWW clerk -> ministerial head -> DCF -> CWW admin.
import CryptoJS from "crypto-js";

const ID_SECRET = "encryptionSecret";

const CWW_ROLES = {
  adminclerk: {
    forwardListUrl: "/adminclerk/forward/list",
    homeRoute: "/AdminClerk",
    detailRoute: "/Adminclerkview",
    encryptId: true,
    targets: [{ key: "Ministerial", label: "CWW MH" }],
  },
  adminsuperint: {
    forwardListUrl: "/adminministerial/forward/list",
    homeRoute: "/AdminMinisterialhead",
    detailRoute: "/Cwwministerial",
    encryptId: false,
    targets: [
      { key: "clerk", label: "CWW Clerk", revert: true },
      { key: "dcf", label: "CWW DCF" },
    ],
  },
  dcf: {
    forwardListUrl: "/dcf/forward/list",
    homeRoute: "/DcfPending",
    detailRoute: "/DcfApplication",
    encryptId: false,
    // Button order: return option first, CWW admin rightmost.
    targets: [
      { key: "ministerial", label: "CWW MH", revert: true },
      { key: "admin", label: "CWW" },
    ],
  },
};

// Applications go to a seat (role + office), not to one person, so the
// option names the seat; the user id is only used to identify that seat.
export function seatLabel(label, user) {
  return user && user.officeName ? `${label} · ${user.officeName}` : label;
}

export function getCwwConfig(role) {
  return CWW_ROLES[role];
}

// Builds the "forward to" options from a forward-list API response.
export function forwardTargets(role, data) {
  return CWW_ROLES[role].targets
    .filter((target) => data[target.key])
    .map((target) => ({
      name: seatLabel(target.label, data[target.key]),
      label: target.label,
      role: target.label,
      userId: data[target.key]._id,
      revert: !!target.revert,
    }));
}

export function detailLocation(role, id) {
  const config = CWW_ROLES[role];
  return {
    path: config.detailRoute,
    query: { id: config.encryptId ? CryptoJS.AES.encrypt(id, ID_SECRET).toString() : id },
  };
}

export function appIdFromQuery(role, queryId) {
  if (!queryId || !CWW_ROLES[role].encryptId) return queryId;
  return CryptoJS.AES.decrypt(queryId, ID_SECRET).toString(CryptoJS.enc.Utf8);
}
